import { Store } from 'store/index';

const isMoreFamiliesToFetch = (store: Store) =>
  store.category.totalFamiliesAvailable > 0 &&
  store.category.totalFamiliesAvailable !== store.category.familiesOffset + store.category.totalFamiliesFetched;

export default isMoreFamiliesToFetch;
